export const textSizeOptions = [
    { value: "h1", label: "Big header" },
    { value: "h2", label: "Medium header" },
    { value: "h3", label: "Small header" },
    { value: "text", label: "Text" },
    { value: "small", label: "Small text" }
];

export const inputTypeOptions = [
    {value: "number", label: "Number"},
    {value: "string", label: "String"},
    {value: "date", label: "Date"},
    {value: "select", label: "Select"},
    {value: "long", label: "Long text"},
    {value: "checkbox", label: "Checkbox"},
    {value: "radio", label: "Radio select"},
    {value: "signature", label: "Signature"},
];

export const areaTypeOptions = [
    {value: "area-single", label: "Single column"},
    {value: "area-double", label: "Double column"},
    {value: "area-triple", label: "2 / 1 / 1"}
];
